module.exports = "https://r.zoocdn.com/_next/static/images/hero-800-6f40c7804f10b8ce49cdf79b16d1ca6b.jpg";